import { FC } from "react";
import * as imageSrcs from "url:../../images/*.png";
import { lookItems } from "../../images";
import Button from "../Button/Button";
import PictureNiceLoader from "../PictureNiceLoader/PictureNiceLoader";
import * as classes from "./look-viewer-item.module.scss";
import content from "../../content.json";

const LookViewerItem: FC<{
  name: string;
  objectKey: string;
  shopUrl: string;
  isSoldOut: boolean;
}> = ({ objectKey, name, shopUrl, isSoldOut }) => {
  if (!lookItems[objectKey]) {
    objectKey = "Placeholder";
  }
  return (
    <div className={classes.root}>
      <PictureNiceLoader
        className={classes.image}
        src={lookItems[objectKey].src}
        sources={[
          { srcSet: lookItems[objectKey].srcSet.jpg, type: "image/jpeg" },
          { srcSet: lookItems[objectKey].srcSet.webp, type: "image/webp" },
        ]}
        sizes="(min-width: 769px) 10vw, 25vw"
        alt={`Product image of the clothing item ${name} on a plain background`}
        hasLoadingSpinner
        width={400}
        height={500}
      />
      <div className={classes.text}>
        <span>
          {isSoldOut ? (
            <span className={classes["sold-out"]}>Sold out</span>
          ) : null}
          <h3
            className={classes.name}
            dangerouslySetInnerHTML={{ __html: name }}
          ></h3>
        </span>
        <Button
          className={classes.button}
          type="link"
          label={isSoldOut ? "Shop collection" : "Shop now"}
          href={isSoldOut ? content.shopUrl : shopUrl}
          disabled={isSoldOut}
          style="outline"
        />
      </div>
    </div>
  );
};

export default LookViewerItem;
